import { BookingTypeSubmitRules } from "../../../../utils/globalEnums";

export function getBookingSubmitTypeName(submitTypeId)
{
  if (submitTypeId === BookingTypeSubmitRules.sendThroughIntacct) return "Intacct";
  if (submitTypeId === BookingTypeSubmitRules.sendFacilityEmail) return "Email";
  if (submitTypeId === BookingTypeSubmitRules.sendFacilityWeeklyEmail) return "Email (Weekly)";
  if (submitTypeId === BookingTypeSubmitRules.sendThroughNHC) return "NHC";
  if (submitTypeId === BookingTypeSubmitRules.sendThroughStellar) return "Stellar";
  if (submitTypeId === BookingTypeSubmitRules.sendThroughPCCAvid) return "PCC Avid";
  if (submitTypeId === BookingTypeSubmitRules.sendThroughPCC) return "PCC";
  if (submitTypeId === BookingTypeSubmitRules.sendThroughWorkday) return "Workday";
  if (submitTypeId === BookingTypeSubmitRules.sendThroughQuickbooks) return "Quickbooks";
  if (submitTypeId === BookingTypeSubmitRules.sendThroughReliable) return "Reliable";
  return "None";
} 

export function getBookingSubmitTypes() {
  return Object.entries(BookingTypeSubmitRules).map(([_, value]) => ({ value, label: getBookingSubmitTypeName(value) })).sort((a, b) => a.label.localeCompare(b.label));
}